import React, { RefObject } from "react";
import "./custom-input.scss";
import { AnimatePresence, motion } from "framer-motion";
import { IoClose, IoCloseCircleOutline } from "react-icons/io5";

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputRef?: RefObject<HTMLInputElement>;
    onClear?: () => void;
    "data-tooltip-id"?: string;
    "data-cy"?: string;
}

const CustomInput: React.FC<CustomInputProps> = (props) => {
    const { inputRef, onClear, ...inputProps } = props;

    return (
        <div className="custom-input">
            <AnimatePresence>
                {props.value && (
                    <motion.button
                        id="clear-guess-btn"
                        onClick={() => {
                            onClear?.();

                            // If the inputRef has the current element, focus on it
                            if (inputRef && inputRef.current) {
                                inputRef.current.focus();
                            }
                        }}
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{ type: "spring", duration: 0.5 }}
                        key="clear-btn"
                        type="button"
                        className="clear-guess-btn"
                    >
                        {inputProps.id === "select-location-input" ? (
                            <IoCloseCircleOutline fontSize={18} />
                        ) : (
                            <IoClose fontSize={14} />
                        )}
                    </motion.button>
                )}
            </AnimatePresence>

            <input ref={inputRef} {...inputProps} />
        </div>
    );
};

export default CustomInput;
